import { render, staticRenderFns } from "./POSBulkUpload.vue?vue&type=template&id=187cdcb2&"
import script from "./POSBulkUpload.vue?vue&type=script&lang=js&"
export * from "./POSBulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports